/**
 * SMS Tour Configuration
 * 
 * Step-by-step tour guide for the SMS page explaining
 * SMS type selection, audience options, sender ID, message composition,
 * and SMS unit calculator.
 */

export const getSMSTourSteps = (t) => [
  {
    selector: '[data-tour="sms-type-audience-encoding"]',
    content: t('tour.sms.typeAudienceEncoding', {
      ns: 'common',
      defaultValue: 'Select SMS type (promotional/transactional/OTP), choose your audience (quick list or file upload), and set encoding.'
    }),
    position: 'bottom'
  },
  {
    selector: '[data-tour="sms-sender-id"]',
    content: t('tour.sms.senderId', {
      ns: 'common',
      defaultValue: 'Enter your Sender ID - this is the name or number that will appear as the sender of your SMS.'
    }),
    position: 'bottom'
  },
  {
    selector: '[data-tour="sms-recipients"]',
    content: t('tour.sms.recipients', {
      ns: 'common',
      defaultValue: 'Enter phone numbers manually or upload a CSV file with contacts. Multiple numbers can be separated by commas.'
    }),
    position: 'bottom'
  },
  {
    selector: '[data-tour="sms-message"]',
    content: t('tour.sms.message', {
      ns: 'common',
      defaultValue: 'Type your SMS message here. The character count and SMS units will be calculated automatically.'
    }),
    position: 'top'
  },
  {
    selector: '[data-tour="sms-calculator"]',
    content: t('tour.sms.calculator', {
      ns: 'common',
      defaultValue: 'SMS Unit Calculator shows how many SMS units your message will use. Each 160 characters equals 1 unit.'
    }),
    position: 'top'
  },
  {
    selector: '[data-tour="sms-submit"]',
    content: t('tour.sms.submit', {
      ns: 'common',
      defaultValue: 'Review everything and click here to send your SMS to all recipients.'
    }),
    position: 'top'
  }
];

